import type { GlobalState } from "../../lib/types";
import { getActiveModule } from "../../store";
import { ModuleTypes } from "../../lib/types";
import { urlConfig } from "../../lib/utils";

export const getSelectedGuideCategory = (state: GlobalState) => {
  return state.guide.selectedCategory;
};

export const getIsGuideActive = (state: GlobalState) => {
  if (urlConfig.guide) {
    return true;
  }
  const activeModule = getActiveModule(state);
  return activeModule && activeModule.type === ModuleTypes.guide;
};
